import { configureCn } from '@mako-comments/utils/cn';

export const cn = configureCn({
  extend: {
    theme: {
      text: ['button'],
    },
  },
});
